<template>
  <div>
    <b-row class="mb-3">
      <b-col
        ><h3 class="d-inline-block mb-0 align-bottom">Dashboards</h3>
        <b-button
          size="sm"
          variant="outline-primary"
          class="d-inline-block ml-3"
          @click="addDashboard"
        >
          Add
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-list-group>
          <b-list-group-item
            v-for="report in reports"
            :key="report.powerBiEmbedUrlId"
            @click="loadDashboard(report)"
            class="dashboard-list-item"
          >
            <b-row>
              <b-col>
                {{ report.dashboardMenuTitle }}
              </b-col>
              <b-col cols="3" sm="2" lg="1">
                <b-badge
                    variant="info"
                    v-if="report.showInBusinessPerformance"
                >Business
                </b-badge>
              </b-col>
              <b-col cols="3" sm="2" lg="1">
                <b-badge
                  variant="secondary"
                  v-if="report.showInBrandPerformance"
                  >Brand
                </b-badge>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>

    <b-modal
      v-model="formModal"
      centered
      hide-header
      size="lg"
      button-size="sm"
      ok-title="Submit"
      @ok="submit"
    >
      <b-form ref="main-form">
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Dashboard Menu Title</div>
            <div>
              <small class="text-muted">The name to show in the menu</small>
            </div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.dashboardMenuTitle"
              placeholder="Monthly Report"
              size="sm"
              autofocus
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Dashboard Code</div>
            <div>
              <small class="text-muted"
                >Unique identifier for the dashboard</small
              >
            </div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.dashboardCode"
              placeholder="monthly-report"
              :disabled="isEdit"
              size="sm"
              pattern="[a-zA-Z0-9-]+"
              title="alphanumeric or dash only"
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Dashboard Group Id</div>
            <div>
              <small class="text-muted">Get this from PowerBI website</small>
            </div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.groupId"
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
              size="sm"
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Dashboard Report Id</div>
            <div>
              <small class="text-muted">Get this from PowerBI website</small>
            </div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.reportId"
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
              size="sm"
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">Show in Business Performance?</b-col>
          <b-col>
            <b-form-checkbox
              v-model="formItems.showInBusinessPerformance"
              :value="true"
              :unchecked-value="false"
            ></b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">Show in Brand Performance?</b-col>
          <b-col>
            <b-form-checkbox
              v-model="formItems.showInBrandPerformance"
              :value="true"
              :unchecked-value="false"
            ></b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
/*global _*/
import http from '@/mixins/http';
import notification from '@/mixins/notification';

export default {
  name: 'DashboardManagement',
  mixins: [http, notification],
  data() {
    const defaultItems = defaultFormItems();
    return {
      reports: [],
      formItems: defaultItems,

      formModal: false,
      isEdit: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.axios.get('/admin/api/dashboards').then(resp => {
        this.reports = resp.data;
      });
    },
    loadDashboard(report) {
      this.isEdit = true;
      this.formItems = _.cloneDeep(report);
      this.formModal = true;
    },
    addDashboard() {
      this.isEdit = false;
      this.formItems = defaultFormItems();
      this.formModal = true;
    },
    submit(e) {
      e.preventDefault();
      const mainForm = this.$refs['main-form'];
      if (!mainForm.reportValidity()) {
        return;
      }
      const formItems = _.cloneDeep(this.formItems);
      if (this.isEdit) {
        this.$bvModal
          .msgBoxConfirm('Proceed to edit the Dashboard?', { centered: true })
          .then(value => {
            if (value) {
              this.formModal = false;
              this.axios
                .put(
                  '/admin/api/dashboards/' + formItems.dashboardCode,
                  formItems
                )
                .then(() => {
                  this.PromptSuccess(
                    'Success',
                    'Dashboard had been updated successfully.'
                  );
                  let reports = _.filter(
                    this.reports,
                    report => report.dashboardCode !== formItems.dashboardCode
                  );
                  reports.push(formItems);
                  this.reports = reports;
                });
            }
          });
      } else {
        this.$bvModal
          .msgBoxConfirm('Proceed to add the Dashboard?', { centered: true })
          .then(value => {
            if (value) {
              this.formModal = false;
              this.axios.post('/admin/api/dashboards', formItems).then(() => {
                this.PromptSuccess(
                  'Success',
                  'Dashboard had been added to the menu successfully.'
                );
                this.reports.push(formItems);
              });
            }
          });
      }
    },
  },
};

const defaultFormItems = () => {
  return {
    dashboardCode: '',
    dashboardMenuTitle: '',
    groupId: '',
    reportId: '',
    showInBusinessPerformance: true,
    showInBrandPerformance: true,
  };
};
</script>

<style scoped>
.dashboard-list-item {
  cursor: pointer;
}

.dashboard-list-item:hover {
  background-color: #ebebeb;
}
</style>